import { FC, useState } from 'react';
import { SvgIcon } from 'src/components/common/SvgIcon';
import { icons } from 'src/configs/icons';
import { setBodyOverflow } from 'src/helpers/utils';
import { CmsGameReplayGroup } from 'src/types/cms/cmsWidgetTypes';
import './styles.scss';

const WinReplaysWidget: FC<{ winReplaysData?: CmsGameReplayGroup | null }> = ({ winReplaysData }) => {
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);
  const [isReady, setIsReady] = useState<boolean>(false);

  const openWinReplaysVideo = (src: string): void => {
    setBodyOverflow('unset');
    setSelectedVideo(src);
    setIsReady(false);
  };

  const handleCloseVideo = (): void => {
    setBodyOverflow('set');
    setSelectedVideo(null);
    setIsReady(false);
  };

  return winReplaysData?.gameReplays ? (
    <div className="winReplays">
      <div className="winReplaysList react-horizontal-scrolling-menu--scroll-container">
        {winReplaysData.gameReplays.map((replay, index) => (
          <button onClick={() => openWinReplaysVideo(replay!.videoUrl)} key={index} className="winReplaysItemWrapper">
            <div className="winReplaysItem">
              <img className="winReplaysItemImage" src={replay!.thumbnail.path} alt={replay!.multiplierText} />
            </div>
            <span className="winReplaysItemName">{replay!.multiplierText}</span>
          </button>
        ))}
      </div>
      {selectedVideo && (
        <div className="winReplays__video">
          <iframe src={selectedVideo} title="Win Replay" frameBorder="0" onLoad={() => setIsReady(true)} />
          {isReady && <SvgIcon src={icons.close} onClick={handleCloseVideo} className="close-game" />}
        </div>
      )}
    </div>
  ) : null;
};

export default WinReplaysWidget;
